import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-simcard-status',
  templateUrl: './simcard-status.component.html',
  styleUrls: ['./simcard-status.component.scss']
})
export class SIMCardStatusComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
